export default __webpack_public_path__ + "static/media/de87ebc81fb0dfd8ad11ea9e0228944f1599576615299.1fbefda2.webp";